<template>
  <div class="applicant-info">
    <el-descriptions :column="2" border size="small">
      <el-descriptions-item label="申请人">{{ displayName }}</el-descriptions-item>
      <el-descriptions-item label="部门">{{ displayDept }}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

/** 占位「—」不写入快照；与展示一致时再同步到父级 formData */
function dashToEmpty(label) {
  if (label == null || label === '') return ''
  return label === '-' ? '' : label
}

export default {
  name: 'ApplicantInfo',
  props: {
    value: { default: null },
    readonly: { type: Boolean, default: true },
    flowInc: { default: null },
    formData: { default: () => ({}) }
  },
  computed: {
    ...mapGetters('user', ['user', 'departments']),
    displayName() {
      // 审批/详情模式：从流程实例获取创建者信息
      if (this.flowInc && this.flowInc.creatorName) {
        return this.flowInc.creatorName
      }
      // 发起模式：从当前登录用户获取
      if (this.user) {
        return this.user.nickname || this.user.username || '-'
      }
      return '-'
    },
    displayDept() {
      // 审批/详情模式：从流程实例获取部门信息
      if (this.flowInc && this.flowInc.creatorDeptName) {
        return this.flowInc.creatorDeptName
      }
      // 发起模式：从当前登录用户的部门列表获取
      if (this.departments && this.departments.length > 0) {
        return this.departments.map(d => d.deptName).join('、')
      }
      return '-'
    },
    /** 与上方展示同源，写入 formData（ApprovalForm → setFieldValue，如 basicInfo.applyMan） */
    applicantFormPayload() {
      return {
        applicantName: dashToEmpty(this.displayName),
        deptName: dashToEmpty(this.displayDept)
      }
    }
  },
  watch: {
    applicantFormPayload: {
      immediate: true,
      deep: true,
      handler(payload) {
        this.$emit('input', { ...payload })
      }
    }
  }
}
</script>

<style scoped>
.applicant-info { padding: 4px 0; }
</style>
